import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_12: FaireProductEntity = {
  token: "driftless-studios-12",
  type: "product",
  name: "Hello Fall Gnome With Flowers Fall Décor Fall Tea Towels",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/8a6440f0871dca056840a3bdb2fcd6e3af4029bd6f6849bb0336df312fb12cfb.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 8.5,
  msrpDollars: 16,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
